import type { TextDirection } from "@yjsgames/i18n";

/**
 * 방향 인지 UI 헬퍼 — phaser 의존 0(순수). RTL 서비스 시 좌우가 뒤집혀야 하는
 * 소형 UI 요소(드롭다운 화살표 위치·팝업 코너 버튼)의 좌표/라벨을 순수 계산한다.
 * LTR 값은 기존 하드코딩과 동일(회귀 0) — 단위테스트로 LTR↔RTL 대칭을 고정한다.
 */

/**
 * 드롭다운 트리거 라벨 — 펼침 화살표 `▼`는 "아래로 펼침"을 뜻하는 **수직** 표시라
 * 글리프 자체는 방향 무관(미러하지 않음). 다만 **위치**는 RTL이면 라벨 왼쪽,
 * LTR이면 라벨 오른쪽에 둬 읽기 시작점(LTR=좌/RTL=우)의 반대편 끝에 오도록 한다.
 */
export function dropdownTriggerLabel(label: string, dir: TextDirection): string {
  return dir === "rtl" ? `▼  ${label}` : `${label}  ▼`;
}

/**
 * 텍스트 originX — LTR=0(좌 정렬 기준), RTL=1(우 정렬 기준).
 * Phaser Text `setOrigin(resolveOriginX(dir), originY)` 또는 레이아웃 객체의
 * `textOriginX` 필드에 사용한다. `rtl ? 1 : 0` 인라인 패턴 대신 이 함수로 통일.
 */
export function resolveOriginX(dir: TextDirection): 0 | 1 {
  return dir === "rtl" ? 1 : 0;
}

/**
 * 팝업 코너 닫기 버튼 x — LTR=우상단, RTL=좌상단(읽기 시작점 반대편 코너).
 * 패널 중심(centerX) 기준 대칭이라 LTR 값은 기존(`cx + w/2 - inset`)과 동일.
 */
export function popupCloseButtonX(
  centerX: number,
  panelWidth: number,
  inset: number,
  dir: TextDirection,
): number {
  return dir === "rtl" ? centerX - panelWidth / 2 + inset : centerX + panelWidth / 2 - inset;
}
